<div class="content">
  <!-- Breadcrumb -->
  <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <div class="my-auto mb-2">
      <h2 class="mb-1">Business Entities</h2>
      <nav>
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <a [routerLink]="[getDashboardRoute()]" href="javascript:void(0);"
              ><i class="ti ti-smart-home"></i
            ></a>
          </li>
          <!-- <li class="breadcrumb-item">
              Employee
            </li> -->
          <li class="breadcrumb-item active" aria-current="page">Business Entities</li>
        </ol>
      </nav>
    </div>
    <div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
      <div class="me-2 mb-2 d-none">
        <div class="dropdown">
          <a
            href="javascript:void(0);"
            class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
            data-bs-toggle="dropdown"
          >
            <i class="ti ti-file-export me-1"></i>Export
          </a>
          <ul class="dropdown-menu dropdown-menu-end p-3">
            <li>
              <a href="javascript:void(0);" class="dropdown-item rounded-1"
                ><i class="ti ti-file-type-pdf me-1"></i>Export as PDF</a
              >
            </li>
            <li>
              <a href="javascript:void(0);" class="dropdown-item rounded-1"
                ><i class="ti ti-file-type-xls me-1"></i>Export as Excel
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="mb-2" *appHasPermission="{ business: ['add'], multiBusiness: ['view'] }">
        <button
          (click)="openBusinessModal(addBusinessModals)"
          class="btn btn-primary d-flex align-items-center"
        >
          <i class="ti ti-circle-plus me-2"></i>Add Business Entity
        </button>
      </div>
      <div class="head-icons ms-2 d-none">
        <a
          href="javascript:void(0);"
          class=""
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          data-bs-original-title="Collapse"
          id="collapse-header"
        >
          <i class="ti ti-chevrons-up"></i>
        </a>
      </div>
    </div>
  </div>
  <!-- /Breadcrumb -->

  <div class="row">
    <!-- Total Companies -->
    <div class="col-lg-3 col-md-6 d-flex">
      <div class="card flex-fill">
        <div class="card-body d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center overflow-hidden">
            <span class="avatar avatar-lg bg-primary flex-shrink-0">
              <i class="ti ti-building fs-16"></i>
            </span>
            <div class="ms-2 overflow-hidden">
              <p class="fs-12 fw-medium mb-1 text-truncate">Total Business Entities</p>
              <h4>{{ totalCount$ | async }}</h4>
            </div>
          </div>
          <!-- <div id="total-chart"></div> -->
          <!-- <apx-chart
            #totalChart
            [series]="totalChartOptions.series"
            [chart]="totalChartOptions.chart"
            [fill]="totalChartOptions.fill"
            [dataLabels]="totalChartOptions.dataLabels"
            [stroke]="totalChartOptions.stroke"
            [colors]="totalChartOptions.colors"
            [tooltip]="totalChartOptions.tooltip"
          >
          </apx-chart> -->
        </div>
      </div>
    </div>
    <!-- /Total Companies -->

    <!-- Total Companies -->
    <div class="col-lg-3 col-md-6 d-flex">
      <div class="card flex-fill">
        <div class="card-body d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center overflow-hidden">
            <span class="avatar avatar-lg bg-success flex-shrink-0">
              <i class="ti ti-building fs-16"></i>
            </span>
            <div class="ms-2 overflow-hidden">
              <p class="fs-12 fw-medium mb-1 text-truncate">Active Business Entities</p>
              <h4>{{ activeCount$ | async }}</h4>
            </div>
          </div>
          <!-- <div id="active-chart"></div> -->
          <!-- <apx-chart
            [series]="activeChartOptions.series"
            [chart]="activeChartOptions.chart"
            [fill]="activeChartOptions.fill"
            [markers]="activeChartOptions.markers"
            [plotOptions]="activeChartOptions.plotOptions"
            [dataLabels]="activeChartOptions.dataLabels"
            [stroke]="activeChartOptions.stroke"
            [colors]="activeChartOptions.colors"
            [xaxis]="activeChartOptions.xaxis"
            [tooltip]="activeChartOptions.tooltip"
          >
          </apx-chart> -->
        </div>
      </div>
    </div>
    <!-- /Total Companies -->

    <!-- Inactive Companies -->
    <div class="col-lg-3 col-md-6 d-flex">
      <div class="card flex-fill">
        <div class="card-body d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center overflow-hidden">
            <span class="avatar avatar-lg bg-danger flex-shrink-0">
              <i class="ti ti-building fs-16"></i>
            </span>
            <div class="ms-2 overflow-hidden">
              <p class="fs-12 fw-medium mb-1 text-truncate">Inactive Business Entities</p>
              <h4>{{ inactiveCount$ | async }}</h4>
            </div>
          </div>
          <!-- <div id="inactive-chart"></div> -->
          <!-- <apx-chart
            [series]="inactiveChartOptions.series"
            [chart]="inactiveChartOptions.chart"
            [fill]="inactiveChartOptions.fill"
            [markers]="inactiveChartOptions.markers"
            [plotOptions]="inactiveChartOptions.plotOptions"
            [dataLabels]="inactiveChartOptions.dataLabels"
            [stroke]="inactiveChartOptions.stroke"
            [colors]="inactiveChartOptions.colors"
            [xaxis]="inactiveChartOptions.xaxis"
            [tooltip]="inactiveChartOptions.tooltip"
          >
          </apx-chart> -->
        </div>
      </div>
    </div>
    <!-- /Inactive Companies -->

    <!-- Company Location -->
    <div class="col-lg-3 col-md-6 d-flex d-none">
      <div class="card flex-fill">
        <div class="card-body d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center overflow-hidden">
            <span class="avatar avatar-lg bg-skyblue flex-shrink-0">
              <i class="ti ti-map-pin-check fs-16"></i>
            </span>
            <div class="ms-2 overflow-hidden">
              <p class="fs-12 fw-medium mb-1 text-truncate">Business Entity Location</p>
              <h4>180</h4>
            </div>
          </div>
          <div id="location-chart"></div>
        </div>
      </div>
    </div>
    <!-- /Company Location -->
  </div>

  <div class="card">
    <div class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
      <h5>Business Entities List</h5>
      <div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
        <div class="me-3">
          <select
            class="form-select form-select-sm col-md-1"
            id="entries"
            name="entries"
            [(ngModel)]="pageLimit"
            (change)="onPageLimitChange()"
          >
            <!-- <option selected disabled>Show Entries Per Page</option> -->
            <option *ngFor="let limit of [10, 20, 50, 100]" [value]="limit">
              {{ limit }}
            </option>
          </select>
        </div>

        <!-- <div class="dropdown me-3">
          <select
            #ownerSelect
            class="js-select2 form-select"
            style="width: 200px"
            [(ngModel)]="businessOwner"
            (change)="loadAllBusinesses()"
          >
            <option value="" selected>Business Owner</option>
            <option *ngFor="let owner of businessOwners$ | async" [value]="owner.id">
              {{ owner.firstName | capitalize }} {{ owner.lastName | capitalize }}
            </option>
          </select>
        </div> -->

        <ng-select
          class="me-3"
          [items]="businessOwners$ | async"
          bindValue="id"
          placeholder="Select Business Owner"
          [(ngModel)]="businessOwner"
          (change)="setCurrentPage()"
          [searchable]="true"
          [clearable]="true"
          [searchFn]="customSearchFn"
          style="width: 200px"
        >
          <ng-template ng-label-tmp let-item="item">
            {{ item.firstName | capitalize }} {{ item.lastName | capitalize }}
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            {{ item.firstName | capitalize }} {{ item.lastName | capitalize }}
          </ng-template>
        </ng-select>

        <div class="dropdown me-3">
          <select
            class="form-select"
            #statusSelect
            [(ngModel)]="status"
            (change)="setCurrentPage()"
          >
            <option value="" selected>Select Status</option>
            <option value="false">Active</option>
            <option value="true">Inactive</option>
          </select>
        </div>

        <div class="form-sort me-3 d-none">
          <select class="form-select">
            <!-- <option selected disabled>Sort By Alphabet</option> -->
            <option value="asc">Ascending</option>
            <option value="desc">Descending</option>
            <!-- <option>Recently Viewed</option>
              <option>Recently Added</option> -->
          </select>
        </div>

        <div class="form-sort search-box">
          <label>
            <input
              appTrimInput
              type="search"
              class="form-control"
              placeholder="Search"
              [(ngModel)]="search"
              (input)="setCurrentPage()"
          /></label>
        </div>
      </div>
    </div>
    <div class="card-body p-0">
      <div class="custom-datatable-filter table-responsive">
        <ng-container *ngIf="businesses$ | async as businesses">
          <table class="table datatable" *ngIf="businesses.length > 0; else noRecords">
            <thead class="thead-light">
              <tr>
                <th>Name</th>
                <th>Owner</th>
                <th>Social</th>
                <th>Status</th>
                <!-- <th>Created</th> -->
                <th>System Information</th>
                <!-- <th>Created By</th> -->
                <!-- <th>Last Modified</th> -->
                <!-- <th>Last Modified By</th> -->
                <th class="text-end">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let business of businesses$ | async">
                <td>
                  <div class="d-flex align-items-center file-name-icon">
                    <a href="javascript:void(0)" class="avatar avatar-md border rounded-circle">
                      <!-- <img
                      [src]="business.picture ? businessImages[business.picture] : defaultImg"
                      class="img-fluid rounded-circle"
                      alt="img"
                    /> -->
                      <ng-container
                        *ngIf="business.picture && businessImages[business.picture]; else initials"
                      >
                        <img
                          [src]="businessImages[business.picture]"
                          (error)="onImageError(business)"
                          class="img-fluid rounded-circle"
                          alt="img"
                          style="width: 100%; height: 100%; object-fit: cover"
                        />
                      </ng-container>

                      <ng-template #initials>
                        <span
                          class="rounded-circle d-inline-flex align-items-center justify-content-center bg-primary text-white fw-bold"
                          style="width: 30px; height: 30px"
                          >{{ getInitials(business.businessName) }}</span
                        >
                      </ng-template>
                    </a>
                    <div class="ms-2">
                      <h6 class="fw-medium">
                        <a [routerLink]="['/company/business', business.id]">{{
                          business.businessName | capitalize
                        }}</a>
                      </h6>
                    </div>
                  </div>
                </td>
                <td>
                  {{ business.user ? (business.user.firstName | capitalize) : 'N/A' }}
                  {{ business.user ? (business.user.lastName | capitalize) : '' }}
                </td>
                <td>
                  <ul class="contact-icon d-flex align-items-center">
                    <li *ngIf="business.referenceIdInstagram">
                      <a
                        href="{{ business.referenceIdInstagram }}"
                        class="p-1 rounded-circle contact-icon-facebook d-flex align-items-center justify-content-center"
                      >
                        <span class="d-flex align-items-center justify-content-center"
                          ><i class="ti ti-brand-instagram text-gray-5"></i></span
                      ></a>
                    </li>
                    <li *ngIf="business.referenceIdFacebook">
                      <a
                        href="{{ business.referenceIdFacebook }}"
                        class="p-1 rounded-circle contact-icon-facebook d-flex align-items-center justify-content-center"
                      >
                        <span class="d-flex align-items-center justify-content-center"
                          ><i class="ti ti-brand-facebook text-gray-5"></i></span
                      ></a>
                    </li>
                    <li *ngIf="business.referenceIdTwitter">
                      <a
                        href="{{ business.referenceIdTwitter }}"
                        class="p-1 rounded-circle contact-icon-facebook d-flex align-items-center justify-content-center"
                      >
                        <span class="d-flex align-items-center justify-content-center"
                          ><i class="ti ti-brand-twitter text-gray-5"></i></span
                      ></a>
                    </li>
                    <li *ngIf="business.referenceIdWhatsapp">
                      <a
                        href="{{ business.referenceIdWhatsapp }}"
                        class="p-1 rounded-circle contact-icon-facebook d-flex align-items-center justify-content-center"
                      >
                        <span class="d-flex align-items-center justify-content-center"
                          ><i class="ti ti-brand-whatsapp text-gray-5"></i></span
                      ></a>
                    </li>
                    <li *ngIf="business.referenceIdLinkedIn">
                      <a
                        href="{{ business.referenceIdLinkedIn }}"
                        class="p-1 rounded-circle contact-icon-facebook d-flex align-items-center justify-content-center"
                      >
                        <span class="d-flex align-items-center justify-content-center"
                          ><i class="ti ti-brand-linkedin text-gray-5"></i></span
                      ></a>
                    </li>
                  </ul>
                </td>
                <td>
                  <span
                    *ngIf="!business.disabled"
                    class="badge badge-success d-inline-flex align-items-center badge-xs"
                  >
                    <!-- -->
                    Active
                  </span>
                  <span
                    *ngIf="business.disabled"
                    class="badge badge-danger d-inline-flex align-items-center badge-xs"
                  >
                    <!-- -->
                    Inactive
                  </span>
                </td>
                <!-- <td>
                  On: {{ business.createdAt | date: 'medium' }} <br />
                  By:
                  {{
                    business.createdByuser
                      ? business.createdByuser.firstName + ' ' + business.createdByuser.lastName
                      : 'Automated User'
                  }}
                </td> -->
                <td>
                  Created By:
                  {{
                    business.createdByuser
                      ? business.createdByuser.firstName + ' ' + business.createdByuser.lastName
                      : 'Automated User'
                  }},
                  {{ business.createdAt | date: 'medium' }}
                  <br />

                  Last Modified By:
                  {{
                    business.lastModifiedByUser
                      ? business.lastModifiedByUser.firstName +
                        ' ' +
                        business.lastModifiedByUser.lastName
                      : 'Automated User'
                  }},
                  {{ business.lastModifiedOn | date: 'medium' }}
                </td>
                <!-- <td>
                  {{
                    business.createdByuser
                      ? business.createdByuser.firstName + ' ' + business.createdByuser.lastName
                      : 'Automated User'
                  }}
                </td> -->
                <!-- <td>
                  On: {{ business.lastModifiedOn | date: 'medium' }}<br />
                  By:
                  {{ business.lastModifiedByUser ? business.lastModifiedByUser?.firstName : '' }}
                  {{ business.lastModifiedByUser ? business.lastModifiedByUser?.lastName : '' }}
                </td> -->
                <!-- <td>
                  {{ business.lastModifiedByUser ? business.lastModifiedByUser?.firstName : '' }}
                  {{ business.lastModifiedByUser ? business.lastModifiedByUser?.lastName : '' }}
                </td> -->
                <td class="text-end">
                  <div class="action-icon d-inline-flex">
                    <a
                      [routerLink]="['/company/business', business.id]"
                      class="me-2"
                      *appHasPermission="{ business: ['edit'] }"
                      ><i class="ti ti-eye"></i
                    ></a>

                    <!-- <a href="javascript:void(0);" class="me-2" ><i [ngClass]="business.disabled === true ? 'ti ti-lock' : 'ti ti-lock-open-2'"></i></a> -->
                    <!-- <a href="javascript:void(0);" class="me-2"  ><i [ngClass]="business.disabled === true ? 'ti ti-lock' : 'ti ti-lock-open-2'"></i></a> -->
                    <!-- <button (click)="openModal(true)">Block User</button>
                  <button (click)="openModal(false)">Unblock User</button> -->
                    <ng-container *ngIf="business.businessName !== 'AVR HRMS'">
                      <ng-container *appHasPermission="{ business: ['edit'] }">
                        <a
                          href="javascript:void(0);"
                          class="me-2"
                          (click)="openModal(false, business.id.toString())"
                          *ngIf="
                            (business.disabled && business.parentBusinessId !== null) || isAdmin
                          "
                        >
                          <i class="ti ti-lock"></i>
                        </a>
                        <a
                          href="javascript:void(0);"
                          (click)="openModal(true, business.id.toString())"
                          *ngIf="
                            (!business.disabled && business.parentBusinessId !== null) || isAdmin
                          "
                          class="me-2"
                        >
                          <i class="ti ti-lock-open-2"></i>
                        </a>
                      </ng-container>
                      <ng-container *appHasPermission="{ business: ['delete'] }">
                        <a
                          href="javascript:void(0);"
                          class="me-2"
                          (click)="openDeleteModal(business.id.toString())"
                          *ngIf="business.parentBusinessId !== null || isAdmin"
                          ><i class="ti ti-trash"></i
                        ></a>
                      </ng-container>
                    </ng-container>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </ng-container>
        <ng-template #noRecords>
          <!-- <div class="d-flex align-items-center justify-content-between ms-2 text-center"> -->
          <div class="text-center">Record not available</div>
          <!-- </div> -->
        </ng-template>
      </div>
    </div>
    <!-- pagination -->
    <!-- <button
      (click)="onPageChange(currentPage - 1)"
      [disabled]="totalCount <= currentPage * pageLimit || totalCount === null"
    >
      Previous
    </button>
    <span>Page {{ currentPage }}</span>
    <button
      (click)="onPageChange(currentPage + 1)"
      [disabled]="totalCount <= currentPage * pageLimit || totalCount === null"
    >
      Next
    </button> -->
    <ng-container *ngIf="businesses$ | async as businesses">
      <div
        class="d-flex align-items-center justify-content-between ms-2"
        *ngIf="businesses.length > 0"
      >
        <!-- <div>
          Showing {{ (currentPage - 1) * pageLimit + 1 }} to {{ pageLastRecord }} of
          {{ totalRowCount }} entries
        </div> -->
        <div>
          Showing {{ (currentPage - 1) * pageLimit + 1 }} to {{ pageLastRecord }} of
          {{ status === 'true' ? inactiveCount : status === 'false' ? activeCount : totalCount }}
          entries
        </div>
        <div class="has-text-centered mt-3">
          <app-pagination
            [currentPage]="currentPage"
            [pageSize]="pageLimit"
            [totalRows]="totalRowCount"
            (pageChange)="onPageChange($event)"
          ></app-pagination>
        </div>
      </div>
    </ng-container>

    <!-- pagination end -->
  </div>
</div>
<app-block-unblock
  *ngIf="showModal"
  [isBlocking]="isBlocking"
  [recordId]="blockBusinessId"
></app-block-unblock>

<app-delete *ngIf="showDeleteModal" [recordId]="blockBusinessId"></app-delete>

<ng-template #addBusinessModals let-modal>
  <!-- <div class="modal custom-modal fade custom-modal-two modal-padding" id="add_company" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content"> -->
  <div class="modal-header header-border justify-content-between m-2">
    <h5 class="modal-title">Add New Business Entity</h5>
    <button
      type="button"
      class="btn-close custom-btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="onClose()"
    >
      <i class="ti ti-x"></i>
    </button>
  </div>
  <div class="modal-body m-2">
    <form [formGroup]="form" autocomplete="off" enctype="multipart/form-data">
      <div class="col-md-12">
        <div class="d-flex align-items-center flex-wrap row-gap-3 bg-light w-100 rounded p-3 mb-4">
          <div
            class="d-flex align-items-center justify-content-center avatar avatar-xxl rounded-circle border border-dashed me-2 flex-shrink-0 text-dark frames"
            style="width: 80px; height: 80px; overflow: hidden"
          >
            <i class="ti ti-photo text-gray-2 fs-16" *ngIf="!imageURL"></i>
            <span>
              <img
                [src]="imageURL"
                alt="Img"
                *ngIf="imageURL"
                class="rounded-circle"
                style="width: 100%; height: 100%; object-fit: cover; display: block"
            /></span>
          </div>
          <div class="profile-upload">
            <div class="mb-2">
              <h6 class="mb-1">Upload Logo</h6>
              <!-- <p class="fs-12">Image should be below 4 mb</p> -->
            </div>
            <div class="profile-uploader d-flex align-items-center">
              <div class="drag-upload-btn btn btn-sm btn-primary me-2">
                Upload
                <input
                  appTrimInput
                  type="file"
                  class="form-control image-sign"
                  name="picture"
                  (change)="onFileChange($event, 'imageURL')"
                />
              </div>
              <!-- <a href="javascript:void(0);" class="btn btn-light btn-sm">Cancel</a> -->
            </div>
          </div>
        </div>
      </div>

      <div class="contact-input-set">
        <div class="row">
          <div class="col-md-12" *ngIf="user?.employmentType === 'Admin'">
            <div class="input-block mb-3">
              <label class="col-form-label" for="isChildBusiness">Is this a child business?</label>

              <div class="form-check form-switch">
                <input
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  formControlName="isChildBusiness"
                  id="isChildBusiness"
                />
                <label class="form-check-label" for="isChildBusiness"> Yes </label>
              </div>
            </div>
          </div>
          <div
            class="col-md-6"
            *ngIf="user?.employmentType === 'Admin' || user?.employmentType === 'Business Owner'"
          >
            <div class="input-block mb-3">
              <label class="col-form-label" for="businessId"
                >Business Entity <span class="text-danger">*</span></label
              >
              <ng-select
                class="me-3"
                [items]="allBusinesses"
                bindValue="id"
                placeholder="Select Parent Business"
                formControlName="parentBusinessId"
                [searchable]="true"
                [clearable]="true"
                [searchFn]="customSearchBusinessFn"
                [readonly]="
                  user?.employmentType !== 'Business Owner' && !form.get('isChildBusiness')?.value
                "
              >
                <ng-template ng-label-tmp let-item="item">
                  {{ item.businessName | capitalize }}
                </ng-template>
                <ng-template ng-option-tmp let-item="item">
                  {{ item.businessName | capitalize }}
                </ng-template>
              </ng-select>
            </div>
          </div>
          <div class="col-md-6">
            <div class="input-block mb-3">
              <label class="col-form-label" for="businessName"
                >Business Entity Name <span class="text-danger"> *</span></label
              >
              <input
                appTrimInput
                formControlName="businessName"
                appTrimInput
                class="form-control"
                name="businessName"
                id="businessName"
              />
              <div *ngIf="form.get('businessName')?.invalid && form.get('businessName')?.touched">
                <span class="text-danger">
                  {{ getErrorMessage('businessName') }}
                </span>
              </div>
              <!-- Other fields for Basic Info here -->
            </div>
          </div>
          <div class="col-md-12">
            <div class="input-block mb-3">
              <label class="col-form-label" for="website"
                >Website <span class="text-danger"> *</span></label
              >
              <input
                appTrimInput
                class="form-control"
                type="text"
                formControlName="website"
                appTrimInput
                type="url"
                id="website"
                name="website"
              />
              <div *ngIf="form.get('website')?.invalid && form.get('website')?.touched">
                <span class="text-danger">
                  {{ getErrorMessage('website') }}
                </span>
              </div>
            </div>
          </div>

          <div
            class="row"
            *ngIf="user?.employmentType === 'Admin' && !form.get('isChildBusiness')?.value"
          >
            <div class="col-md-6">
              <div class="input-block mb-3">
                <label class="col-form-label">
                  First Name <span class="text-danger">*</span>
                </label>

                <input type="text" class="form-control" formControlName="ownerFirstName" />

                <div
                  *ngIf="form.get('ownerFirstName')?.touched && form.get('ownerFirstName')?.invalid"
                >
                  <span class="text-danger">
                    {{ getErrorMessage('ownerFirstName') }}
                  </span>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="input-block mb-3">
                <label class="col-form-label"> Last Name <span class="text-danger">*</span> </label>

                <input type="text" class="form-control" formControlName="ownerLastName" />

                <div
                  *ngIf="form.get('ownerLastName')?.touched && form.get('ownerLastName')?.invalid"
                >
                  <span class="text-danger">
                    {{ getErrorMessage('ownerLastName') }}
                  </span>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="input-block mb-3">
                <label class="col-form-label"> Email <span class="text-danger">*</span> </label>

                <input type="email" class="form-control" formControlName="ownerEmail" />

                <div *ngIf="form.get('ownerEmail')?.touched && form.get('ownerEmail')?.invalid">
                  <span class="text-danger">
                    {{ getErrorMessage('ownerEmail') }}
                  </span>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="input-block mb-3">
                <label class="col-form-label">
                  Mobile Number <span class="text-danger">*</span>
                </label>

                <input type="text" class="form-control" formControlName="ownerMobile" />

                <div *ngIf="form.get('ownerMobile')?.touched && form.get('ownerMobile')?.invalid">
                  <span class="text-danger">
                    {{ getErrorMessage('ownerMobile') }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div
            class="col-md-6"
            *ngIf="user?.employmentType === 'Admin' && !form.get('isChildBusiness')?.value"
          >
            <div class="input-block mb-3">
              <label class="col-form-label" for="planId"
                >Select Plan <span class="text-danger">*</span></label
              >
              <ng-select
                class="me-3"
                [items]="plans"
                bindValue="id"
                bindLabel="name"
                placeholder="Select Plan to Start Trial"
                formControlName="planId"
                [searchable]="true"
                [clearable]="true"
                [searchFn]="customSearchPlanFn"
              >
                <ng-template ng-label-tmp let-item="item">
                  {{ item.name | capitalize }}
                </ng-template>
                <ng-template ng-option-tmp let-item="item">
                  {{ item.name | capitalize }}
                </ng-template>
              </ng-select>
              <div *ngIf="form.get('planId')?.invalid && form.get('planId')?.touched">
                <span class="text-danger">
                  {{ getErrorMessage('planId') }}
                </span>
              </div>
              <small class="text-muted"
                >Selecting a plan will start a trial for this business.</small
              >
            </div>
          </div>

          <div class="col-lg-12 text-end form-wizard-button">
            <button
              type="submit"
              (click)="onSubmit()"
              [disabled]="!form.valid"
              class="btn btn-primary wizard-next-btn"
            >
              <ng-container *ngIf="isLoading$ | async; else loading">
                <span
                  class="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Submit...
              </ng-container>
              <ng-template #loading> Submit </ng-template>
            </button>
          </div>
        </div>
      </div>
    </form>

    <!-- end tab content -->
  </div>
  <!-- </div>
    </div>
  </div> -->
</ng-template>
